import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { feedbacksAnimationTrigger, slideIn } from '../teacher-feedback-animations';
import { TeacherFeedbackResponseStatus } from '../teacher-feedback-response-status/teacher-feedback-response-status';
import { LegacyTeacherFeedbackService } from '../teacher-feedback-service/legacy-teacher-feedback.service';
import { LiveClassCriteriaList } from '../teacher-feedback-service/live-class-criteria';
import { FeedbackResponseDTO } from '../teacher-feedback-service/private-class-feedback-dto';
import { TeacherFeedbackDto } from '../teacher-feedback-service/teacher-feedback-dto';
import { TeacherFeedbackType } from '../teacher-feedback-service/teacher-feedback-type';
import { FeedbackCategoryMessage } from '../feedback-category-message';

@Component({
  selector: 'lp2-teacher-feedback-detail',
  templateUrl: './teacher-feedback-detail.component.html',
  styleUrls: ['./teacher-feedback-detail.component.scss'],
  animations: [feedbacksAnimationTrigger, slideIn],
})
export class TeacherFeedbackDetailComponent implements OnInit {
  @Input() feedback: TeacherFeedbackDto;
  @Output() feedbackChange: EventEmitter<TeacherFeedbackDto> = new EventEmitter();

  status: TeacherFeedbackResponseStatus;
  userAvatar = { image: '' };
  teacherAvatar = { image: '' };
  avatarHeightWidth = 42;
  isFeedbackRatingDisplayed = false;
  defaultFeedbackTypesWithRate = [TeacherFeedbackType.ASK_A_TEACHER, TeacherFeedbackType.WRITING_FEEDBACK];
  isLiveClass = false;

  isPrivateClass = false;
  privateClassKeyword = 'Private Class';
  privateClassFeedback: FeedbackResponseDTO;
  privateClassFeedbackCategoryMessages: FeedbackCategoryMessage[] = [];
  isLoading = false;

  TeacherFeedbackType = TeacherFeedbackType;
  requestType: TeacherFeedbackType;
  displayTestScore = false;
  displayFeedbackRequest = true;

  animateMessages = 0;

  constructor(private legacyTeacherFeedbackService: LegacyTeacherFeedbackService) {}

  ngOnInit(): void {
    if (!this.feedback) {
      return;
    }

    this.requestType = <TeacherFeedbackType>this.feedback.requestType;
    if (this.defaultFeedbackTypesWithRate.indexOf(this.requestType) > -1) {
      this.isFeedbackRatingDisplayed = true;
    }
    if (this.requestType === TeacherFeedbackType.LIVE_CLASS_FEEDBACK) {
      this.isLiveClass = true;
      this.displayFeedbackRequest = false;
    }
    this.isPrivateClass = this.feedback.text && this.feedback.text.indexOf(this.privateClassKeyword) > -1;
    if (this.isPrivateClass) {
      this.getPrivateClassFeedback();
    }
    if (this.requestType === TeacherFeedbackType.LEVEL_TEST_FEEDBACK) {
      this.displayFeedbackRequest = false;

      if (this.feedback.response.testScorePercentage >= 70) {
        this.displayTestScore = true;
      }
    }
    this.animateMessages = this.animateMessages + 1;
    this.updateViewedStatus();
  }

  updateViewedStatus() {
    if (!this.feedback.response || this.feedback.response.id === null) {
      return;
    }
    const status = this.legacyTeacherFeedbackService.getFeedbackStatus(this.feedback);
    if (status === TeacherFeedbackResponseStatus.NEW) {
      this.legacyTeacherFeedbackService.postViewedFeedback(this.feedback.response.id).subscribe(() => {
        this.feedback.response.viewed = new Date().valueOf();
        this.feedbackChange.emit(this.feedback);
        this.status = this.legacyTeacherFeedbackService.getFeedbackStatus(this.feedback);
      });
    }
  }

  getPrivateClassFeedback() {
    this.isLoading = true;
    this.legacyTeacherFeedbackService.getPrivateclassFeedbackDetail(this.feedback.response.id).subscribe((response) => {
      this.privateClassFeedback = response;
      this.privateClassFeedbackCategoryMessages = this.joinMessagesOfSameCategory(response.liveClassCriteriaList);
      this.isLoading = false;
      this.animateMessages = this.animateMessages + 1;
    });
  }

  joinMessagesOfSameCategory(criteriaList: LiveClassCriteriaList[]): FeedbackCategoryMessage[] {
    const criteriaMessageList: FeedbackCategoryMessage[] = [];
    criteriaList.forEach((criteria) => {
      const sameCriteriaMessage = criteriaMessageList.find((cat) => cat.category === criteria.category);
      if (sameCriteriaMessage) {
        sameCriteriaMessage.messages.push(criteria.liveClassCriteriaPerformanceDTO.description);
      } else {
        const newCriteriaMessage: FeedbackCategoryMessage = {
          category: criteria.category,
          messages: [criteria.liveClassCriteriaPerformanceDTO.description],
        };
        criteriaMessageList.push(newCriteriaMessage);
      }
    });
    return criteriaMessageList;
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-detail/teacher-feedback-detail.component.ts